import { t } from 'i18next';

export enum FilterStatus {
  FULLY_KEPT = 'FULLY_KEPT',
  PARTIALLY_KEPT = 'PARTIALLY_KEPT',
  NOT_KEPT = 'NOT_KEPT',
}

type LabelOptions = {
  omitFullyKept?: boolean;
};

export const getFilterStatusLabel = (filterStatus: FilterStatus, options: LabelOptions = {}) => {
  const { omitFullyKept } = options;
  if (omitFullyKept && filterStatus === FilterStatus.FULLY_KEPT) {
    return '';
  }
  return t(`instanceFilterStatus.${filterStatus}`);
};
